import React, { useEffect, useRef, useState } from "react";

import {
  convertToDefEventPara,
  orderStatusOptions,
  yesOrNoOptions,
  isReadOnlyUser,
  formatDate,
} from "../../../shared/utility";
import OrderNotesModal from "./OrderNotesModal";
import SelectMenu from "../../controls/SelectMenu";
import OrderProductsTable from "./OrderProductsTable";
import DeleteConfirmationForm from "../DeleteConfirmationForm";
import Input from "../../controls/Input";
import { useForm } from "../useForm";
import ButtonDropdown from "../../controls/ButtonDropdown";

const initialFValues = {
  id: 0,
  customer: null,
  customer_id: null,
  po_number: "",
  order_date: new Date(),
  expected_date: null,
  status: null,
  notes: "",
  mixed_cartons: [],
  credit_returns: [],
};

export default function CreateNewOrderForm(props) {
  const {
    carriers,
    customers,
    isEdit,
    loading,
    order,
    setEmptyModelOpen,
    showErrorModal,
    updateOrderApiCall,
    onUpdateOrderItem,
    printOrderInvoice,
    printShippingSummary,
    printShippingDetails,
    closed,
  } = props;

  const isReadOnly = isReadOnlyUser();

  const buttonOptions = [
    {
      name: "Print Invoice",
      onClick: printOrderInvoice,
      inProgress: false,
    },
    {
      name: "Print Shipping Summary",
      onClick: printShippingSummary,
      inProgress: false,
    },
    {
      name: "Print Shipping Slip",
      onClick: printShippingDetails,
      inProgress: false,
    },
  ];

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    temp.customer = null;
    if (values.customer === "") {
      temp.customer = "Please fill out field.";
    }

    temp.expected_date = null;
    if (values.expected_date === "") {
      temp.expected_date = "Please fill out field.";
    }

    temp.po_number = null;
    if (values.po_number === "") {
      temp.po_number = "Please fill out field.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate
  );

  useEffect(() => {
    if (order) {
      var truckQuestion1 = [];
      if (order.truck_question_1) {
        truckQuestion1 = yesOrNoOptions.find(
          (el) => el.value === order.truck_question_1
        );
      }

      var truckQuestion2 = [];
      if (order.truck_question_2) {
        truckQuestion2 = yesOrNoOptions.find(
          (el) => el.value === order.truck_question_2
        );
      }

      var truckQuestion3 = [];
      if (order.truck_question_3) {
        truckQuestion3 = yesOrNoOptions.find(
          (el) => el.value === order.truck_question_3
        );
      }

      var truckQuestion4 = [];
      if (order.truck_question_4) {
        truckQuestion4 = yesOrNoOptions.find(
          (el) => el.value === order.truck_question_4
        );
      }

      const orderCopy = {
        ...order,
        status: orderStatusOptions.filter(
          (option) => option.value === order.status
        )[0],
        customer: customers.filter(
          (option) => option.value === order.customer_id
        )[0],
        carrier: carriers.filter(
          (option) => option.value === order.carrier_id
        )[0],
        truck_question_1: truckQuestion1,
        truck_question_2: truckQuestion2,
        truck_question_3: truckQuestion3,
        truck_question_4: truckQuestion4,
      };
      setValues(orderCopy);
    }
  }, [order]);

  const handleSubmit = () => {
    console.log("helo");
    if (validate()) {
      updateOrderApiCall(values);
    }
  };

  const updateItemLocally = (newData, index) => {
    // Update source_item in the mixed_cartons structure
    if (values.mixed_cartons) {
      const updatedMixedCartons = values.mixed_cartons.map((mixedCarton) => {
        if (mixedCarton.source_items) {
          const updatedSourceItems = mixedCarton.source_items.map((sourceItem) => {
            if (sourceItem.id === newData.id) {
              return { ...sourceItem, ...newData };
            }
            return sourceItem;
          });
          return { ...mixedCarton, source_items: updatedSourceItems };
        }
        return mixedCarton;
      });
      setValues({ ...values, mixed_cartons: updatedMixedCartons });
    }
  };

  const onItemEditComplete = async function (newData, index) {
    if (isEdit) {
      const onUpdateCompleted = await onUpdateOrderItem(newData);

      if (onUpdateCompleted.success) {
        updateItemLocally(newData, index);
      }
    }
  };

  return (
    <div>
      {order || !isEdit ? (
        <div className="grid grid-cols-3 gap-3 h-full">
          <div className="col-span-2">
            <div className="card-custom p-2">
              <OrderProductsTable
                loading={false}
                values={values}
                onItemEditComplete={onItemEditComplete}
              />
            </div>
          </div>

          <div className="col-span-1 space-y-5">
            <div className="card-custom p-3 space-y-2">
              <Input
                label="Created By"
                name="created_by"
                onChange={handleInputChange}
                value={values.created_by_name}
                labelOn={true}
                type="text"
                error={errors.created_by_name}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                disabled={true}
              />

              <SelectMenu
                handleInputChange={handleInputChange}
                name="customer"
                options={customers.filter((option) => option.value !== -1)}
                value={isEdit ? values.customer : null}
                title={"Customer"}
                error={errors.customer}
                showLabel={true}
                disabled={closed}
              />

              <Input
                label="PO #"
                name="po_number"
                onChange={handleInputChange}
                value={values.po_number}
                labelOn={true}
                type="text"
                error={errors.po_number}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                disabled={true}
              />
              
              <Input
                label="Shipped Date"
                name="created_at"
                onChange={handleInputChange}
                value={formatDate(values.created_at)}
                labelOn={true}
                type="text"
                error={errors.created_at}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                disabled={true}
              />

              <SelectMenu
                handleInputChange={handleInputChange}
                name="carrier"
                options={carriers.filter((option) => option.value !== -1)}
                value={isEdit ? values.carrier : null}
                title={"Carrier"}
                error={errors.carrier}
                showLabel={true}
                disabled={closed}
              />

              {isEdit ? (
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="status"
                  options={orderStatusOptions.filter(
                    (option) => option.value !== -1
                  )}
                  value={isEdit ? values.status : null}
                  title={"Status"}
                  error={errors.status}
                  showLabel={true}
                  disabled={closed}
                />
              ) : null}

              <SelectMenu
                name="truck_question_1"
                options={yesOrNoOptions}
                value={values.truck_question_1}
                handleInputChange={handleInputChange}
                title="Truck is clean, no foul odour or condensation present"
                error={errors.truck_question_1}
                disabled={closed}
              />
              <SelectMenu
                name="truck_question_2"
                options={yesOrNoOptions}
                value={values.truck_question_2}
                handleInputChange={handleInputChange}
                title="Truck has no rust, mold, flaking paint. No damage to floors, walls or ceiling"
                error={errors.truck_question_2}
                disabled={closed}
              />
              <SelectMenu
                name="truck_question_3"
                options={yesOrNoOptions}
                value={values.truck_question_3}
                handleInputChange={handleInputChange}
                title="Truck doors are sealed properly to prevent entrance of pests, dust and foreign material during transport"
                error={errors.truck_question_3}
                disabled={closed}
              />
              <SelectMenu
                name="truck_question_4"
                options={yesOrNoOptions}
                value={values.truck_question_4}
                handleInputChange={handleInputChange}
                title={"Product condition is acceptable"}
                error={errors.truck_question_4}
                disabled={closed}
              />
              {!isReadOnly && (
                <div className="mt-3 flex flex-shrink-0 py-4">
                  {isEdit ? (
                    <ButtonDropdown
                      mainOption="Save"
                      items={buttonOptions}
                      mainAction={handleSubmit}
                      disabled={closed}
                    />
                  ) : null}
                </div>
              )}
            </div>

            <div className="card-custom p-3 mt-3">
              <div className="flex justify-between">
                <p className="text-sm text-gray-700 font-semibold">Notes</p>
                <button
                  onClick={() =>
                    setEmptyModelOpen({
                      childComponent: (
                        <OrderNotesModal
                          orderNote={values.notes}
                          confirmAction={(newNote) =>
                            handleInputChange(
                              convertToDefEventPara("notes", newNote)
                            )
                          }
                          setOpen={setEmptyModelOpen}
                        />
                      ),
                      open: true,
                    })
                  }
                  className="text-sm font-semibold main-purple"
                  disabled={closed}
                >
                  Edit
                </button>
              </div>
              <p className="text-sm text-gray-700 font-normal">
                {values.notes ? values.notes : "No notes"}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
